"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var BackIos_1 = __importDefault(require("@pixum/svg-icon/lib/Arrows/BackIos"));
var ForwardIos_1 = __importDefault(require("@pixum/svg-icon/lib/Arrows/ForwardIos"));
var IconButton_1 = __importDefault(require("../IconButton/IconButton"));
var text_1 = __importDefault(require("@pixum/text"));
require("./style.css");
var Pagination = function Pagination(_a) {
  var className = _a.className,
    _b = _a.disableNextButton,
    disableNextButton = _b === void 0 ? false : _b,
    _c = _a.disablePrevButton,
    disablePrevButton = _c === void 0 ? false : _c,
    onNextClick = _a.onNextClick,
    onPrevClick = _a.onPrevClick,
    _d = _a.position,
    position = _d === void 0 ? 'bottom' : _d,
    text = _a.text,
    titleNextButton = _a.titleNextButton,
    titlePrevButton = _a.titlePrevButton;
  return react_1.default.createElement("div", {
    className: (0, clsx_1.default)('pagination', className)
  }, react_1.default.createElement(text_1.default, {
    className: "text--centered",
    variant: "body"
  }, text), react_1.default.createElement(IconButton_1.default, {
    disabled: disablePrevButton,
    onClick: onPrevClick,
    testID: position + "-back",
    title: titlePrevButton
  }, react_1.default.createElement(BackIos_1.default, null)), react_1.default.createElement(IconButton_1.default, {
    disabled: disableNextButton,
    onClick: onNextClick,
    testID: position + "-forward",
    title: titleNextButton
  }, react_1.default.createElement(ForwardIos_1.default, null)));
};
exports.default = Pagination;